<template>
  <div id="add" class="center-me">
    <transition name="company">
      <l-alert border="lhred" :styleClass="alertClass" :text="text" v-if="alert"></l-alert>
      <l-alert border="lgreen" :styleClass="alertSuccess" :text="text" v-if="success"></l-alert>
    </transition>

    <h1 style="text-align: center; font-size: 1.8rem;" class="my-2 font-weight-medium mb-5">Create new cards</h1>
    
      <v-flex xs12 style="width: 90%" sm12 lg8 class="center-me">

        <v-col cols="12" sm="8">
          <v-text-field
            @keyup.enter.native="addCard"
            label="Task Name"
             required
            v-model="name"
            color="white"
            class="main--text"
            placeholder="website"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="8">
          <v-textarea
            name="input-7-1"
            label="Description"
             color="white"
            class="main--text"
            :rules="[rules.length(200)]"
            max-height="100px"
            counter="200"
            v-model="desc"
            placeholder="website"
          ></v-textarea>
          
        </v-col>

         <v-col cols="12" sm="8">
          <v-text-field
            @keyup.enter.native="addCard(event)"
            label="Website (e.g google.com)"
            v-model="website"
            color="white"
            class="main--text"
            placeholder="website"
          ></v-text-field>
        </v-col>


      <div class="center-me">      
        <v-btn v-if="products.length <= 14" width="130" height="42" class="main" @click="addCard">Add</v-btn>

        <div style="color: #F2F2F2; padding-top: 6px" v-if="products.length <= 14">You have {{products.length}} cards in your Task Board</div>

        <div style="text-align: center" v-else>
          <span style="color: #F2F2F2">Stack limit reached (15 Cards)</span>
          <br />
          <span style="color: #F2F2F2">
            Delete one or more cards to create more!
          </span>
        </div>
      </div>

    </v-flex>
  </div>
</template>

<script>
import lAlert from "@/components/alert";
import lButton from "@/components/button";
import { mapState } from "vuex";
import { firestore } from "@/firebase/async-firestore";
import firebase from "firebase/app";
import "firebase/firestore";

// create custom unique uuid
export const uuidv44 = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
};

export default {
  data() {
    return {
      rules: {
        length: len => v => (v || '').length <= len || `Invalid character length, max. length ${len}`,
      },
      name: "",
      desc: "",
      website: "",
      alert: false,
      text: "",
      number: 0,
      activate: false,
      addBtn: 'add-btn',
      success: false,
      alertClass: 'alert-normal',
      alertSuccess: 'alert-success'
    };
  },
  components: {
    lAlert,
    lButton
  },
  computed: {
    ...mapState("user", ["currentUser", "userProfile"]),
    ...mapState("posts", ["products"])
  },
  mounted () {
    this.$nextTick(() => {
            this.$el.setAttribute('style', 'padding-bottom:' + (this.$el.scrollHeight) + 'px;overflow-y:hidden;')
        })

        this.$el.addEventListener('input', this.resizeTextarea)
    },
    beforeDestroy () {
        this.$el.removeEventListener('input', this.resizeTextarea)
    },
    render () {
        return this.$slots.default[0]
  },
  watch: {
    desc() {
      if (this.desc.length > 200) {this.activate = true} else {this.activate = false}
      return this.number = this.desc.length
    }
  },
  methods: {
    resizeTextarea (event) {
            event.target.style.height = 'auto'
            event.target.style.height = (event.target.scrollHeight) + 'px'
        },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    close() {
      this.alert = false;
    },
    addCard(event) {
      const uuidv4 = uuidv44();
      if (this.products.length >= 15) {
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 2000);
        this.text = "Task stack limit reached";
      } 
      else {
        if (this.name === "") {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 2000);
          return this.text = "Add task name";
        } 
        else if (this.activate === true) {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 2000);
          return this.text = "Description to long";
        }
         else if (this.name !== "" && this.activate === false) {
          const endName = this.capitalizeFirstLetter(this.name);
          const pos = this.userProfile.last_position;

          const postData = {
            name: this.capitalizeFirstLetter(this.name),
            desc: this.desc,
            website: this.website,
            active: false,
            view: true,
            priority: "",
            userId: this.currentUser.uid,
            uuid: uuidv4,
            last_position: this.userProfile.last_position
          };

          this.$store
            .dispatch("posts/triggerAddProductAction", { postData, pos })
            .then(() => {
              this.success = true;
              setTimeout(() => {
                this.success = false;
              }, 2000);
              this.text = "New task created";
              this.name = "";
              this.desc = "";
              this.website = "";
            })
            .then(async () => {
              firebase
                .firestore()
                .collection("users")
                .doc(this.currentUser.uid)
                .update({
                  last_position:
                    Number(this.userProfile.last_position) + Number(1)
                });
            });
        }
      }
    }
  }
};
</script>

<style>
#add .theme--light.v-input:not(.v-input--is-disabled) input,
#add .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: #fff !important;
}

.alert-normal {
  background: #FCE8E6 !important;
  color: #D60509 !important;
}
.alert-success {
  background: rgb(176, 255, 176) !important;
  color: #29CC41 !important;
}
</style>